export default '/src/assets/webgl/caris/audios/global_intro.mp3'